import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSearch(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m13.667 13.667-2.8-2.8m1.466-3.534a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
